import { useEffect, useState } from "react";

/**
 * Hides fixed header/footer when user scrolls down; shows again near top or on scroll up.
 * Keeps chrome visible for the first ~48px of scroll for context.
 */
export function useScrollChromeVisibility() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    let lastY = window.scrollY;
    let ticking = false;

    const update = () => {
      const y = window.scrollY;

      if (y < 48) {
        setVisible(true);
      } else if (y > lastY + 6) {
        setVisible(false);
      } else if (y < lastY - 6) {
        setVisible(true);
      }

      lastY = y;
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return visible;
}
